import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageWrapper from '../components/PageWrapper';
import { PAGE_CTAS } from '../components/marketing/pageCtas';
import MarketingHero from '../components/marketing/MarketingHero';
import MarketingSection from '../components/marketing/MarketingSection';
import FadeIn from '../components/marketing/FadeIn';
import FormSuccessPanel from '../components/marketing/FormSuccessPanel';
import { FloatingInput, FloatingTextarea } from '../components/marketing/FloatingField';
import { EASE_REFINED } from '../components/marketing/constants';

const CONTACT_ITEMS = [
  {
    label: 'Email',
    value: 'hello@stavyn.com',
    href: 'mailto:hello@stavyn.com',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <rect x="1" y="3.5" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="0.875" />
        <path d="M1 5l7 5 7-5" stroke="currentColor" strokeWidth="0.875" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    label: 'Response time',
    value: "We'll get back to you within 24 hours",
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="0.875" />
        <path d="M8 4.5V8l2.5 2" stroke="currentColor" strokeWidth="0.875" strokeLinecap="round" />
      </svg>
    ),
  },
];

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }

  return (
    <PageWrapper cta={PAGE_CTAS.contact}>
      <MarketingHero
        eyebrow="Contact"
        title="Get in touch."
        subtitle="Questions about Stavyn? Our team is here to help."
      />

      <MarketingSection padding="sm" maxWidth="5xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <FadeIn delay={0.1}>
            <div>
              <div className="marketing-form-panel__label">Contact Information</div>

              {CONTACT_ITEMS.map((item) => (
                <div key={item.label} className="marketing-contact-item">
                  <div className="marketing-contact-item__icon">{item.icon}</div>
                  <div>
                    <div className="marketing-contact-item__label">{item.label}</div>
                    {item.href ? (
                      <a href={item.href} className="marketing-contact-item__value">
                        {item.value}
                      </a>
                    ) : (
                      <div className="marketing-contact-item__value">{item.value}</div>
                    )}
                  </div>
                </div>
              ))}

              <div className="glass-panel marketing-info-card" style={{ marginTop: '3rem' }}>
                <h2 className="marketing-info-card__title">Want a free risk report?</h2>
                <p className="marketing-info-card__body">
                  Request a complimentary retention risk snapshot for your organization — no commitment required.
                </p>
                <Link to="/schedule-demo" className="landing-cta landing-cta--hero">
                  Get Free Risk Report
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                    <path d="M1.5 5h7M6 2l3 3-3 3" stroke="currentColor" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Link>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            {submitted ? (
              <FormSuccessPanel
                title="Message sent."
                message="We'll be in touch within one business day."
              />
            ) : (
              <div className="glass-panel marketing-form-panel">
                <div className="marketing-form-panel__label">Send a Message</div>
                <form onSubmit={handleSubmit}>
                  <FloatingInput label="Your Name" name="name" required />
                  <FloatingInput label="Email Address" type="email" name="email" required />
                  <FloatingInput label="Company" name="company" />
                  <FloatingTextarea label="Message" name="message" required rows={5} />
                  <motion.button
                    type="submit"
                    className="landing-cta landing-cta--hero marketing-form-submit"
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.98 }}
                    transition={{ duration: 0.3, ease: EASE_REFINED }}
                    style={{ justifyContent: 'center', width: '100%' }}
                  >
                    Send Message
                  </motion.button>
                </form>
              </div>
            )}
          </FadeIn>
        </div>
      </MarketingSection>
    </PageWrapper>
  );
}
